import Vue from "vue";
import Vuex from 'vuex';
import App from "./App.vue";
import router from "./router/index";
import EventBus from './EventBus'
import "@/assets/css/common.scss";
import Element from "element-ui";
import OkrElCollapse from "@/components/common/OkrCollapse/index.js";
import OkrElCollapseItem from "@/components/common/OkrCollapse/itemIndex.js";

import "core-js/fn/promise";
// import LockPlugin from "@/utils/lock";
import LSWatcher from "vue-storage-watcher";
import mixin from "@/mixin";
import Waves from "@/directives/waves/index.js";
import Bubble from "@/directives/bubble/index.js";
import Zoom from "@/directives/zoom/index.js";
import watermark from "@/directives/watermark/index";
import Popover from "@/components/common/Popover/Popover";
import YachPopover from "@/components/common/yachShare/YPopover";
import VueClipboard from "vue-clipboard2";
import elementResizeDetectorMaker from "element-resize-detector";

import placeholderFilter from "@/filter/placeholder";
// import pathFilter from "@/filter/path";
import linebreakFilter from "@/filter/linebreak";
import "./registerServiceWorker";
// import "core-js/fn/array/includes";
//* wather polyfill for IE 11
import "core-js/fn/symbol";
import "core-js/fn/map";
import "@/assets/font/iconfont.css";

import okrDetail from "./constants/okrDetail";
import feedGlobalFlage from "./constants/feedGlobalFlage";

// 引入 sentry
import Raven from "raven-js";
import RavenVue from "@/utils/sentry";

// 百度统计 2019 11 26 下架
// import "../src/utils/Hmt";

// yach
import yach from "yach-jsapi";

// sensors 神策
import { init as sensorsInit } from "@/utils/sensors/sensors";
// 常量
import { LSKeys } from "@/constants/Key";
// 判断
import { task } from "@/constants/api/MYOKR_API";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import createStore from '@/store';

//获取语言
import i18n from '@/locale/index'
const oldVConsoleFlag = process.env.VUE_APP_KEY == "754722778" || process.env.VUE_APP_KEY == "661526935" || process.env.VUE_APP_CONSOLE_YACH == "1458664430";


// 移动端开发调试工具
if (
  process.env.NODE_ENV !== "development" && oldVConsoleFlag
) {
  const VConsole = require("vconsole");
  /* eslint-disable no-new */
  new VConsole();
}
Vue.prototype.elementResizeDetectorMaker = elementResizeDetectorMaker;
Vue.prototype.$okrDetail = okrDetail;
Vue.prototype.$EventBus = EventBus
// feedback全局变量
Vue.prototype.$isShowFeed = feedGlobalFlage;

Vue.prototype.$htmlInit = function(val: string = ""): string {
  try {
    let value = val.replace(/<[^>]+>/g, "");
    value = value.replace(/&lt;/g, "<");
    value = value.replace(/&gt;/g, ">");
    value = value.replace(/&nbsp;/g, " ");
    value = value.replace(/&amp;/g, "&");
    return value;
  } catch (e) {
    return "";
  }
};

Vue.prototype.$atRedPot = function() {
  task({})
    .then(res => {
      this.$ls.set(LSKeys.atTask, res.notAlignAtCount);
    })
    .catch(_ => {});
};

(window as any).yach = yach;
if ((window as any).yach.platform !== "notInYach") {
  (window as any).dd = (window as any).yach;
  // console.log((window as any).dd);
  (window as any).dd.pc = (window as any).dd.platform === "pc";
}

// sentey const RavenPlugin: Raven.RavenPlugin = RavenVue;
const RavenPlugin: any = RavenVue;
Raven.config(process.env.VUE_APP_CENTRY, {
  environment: process.env.NODE_ENV,
  captureUnhandledRejections: true
})
  .addPlugin(RavenPlugin, Vue)
  .install();

(window as any).Sentry &&
  (window as any).Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_URL!,
    environment: process.env.VUE_APP_ENV_TYPE,
    integrations: [
      new (window as any).Sentry.Integrations.Vue({
        Vue,
        attachProps: true,
        logErrors: true
      })
    ],
    ignoreErrors: [
      "Do not support the current environment：notInDingTalk",
      /^Non-Error exception captured with keys:/,
      /^Non-Error promise rejection captured with keys/,
      /^AbortError: The operation was aborted/
    ]
  });

//! FIXME: pls change prefix
Vue.use({ ...LSWatcher }, { prefix: "okr_" });
Vue.use({ ...LSWatcher }, { prefix: "okr_", storage: "session" });

// sensors 神策init
Vue.$ls.on(
  "userInfo",
  () => {
    const userInfo = Vue.$ls.get("userInfo");
    if (userInfo && userInfo.workcode) {
      sensorsInit(userInfo.workcode);
    }
  },
  true
);
Vue.use(Vuex);
Vue.mixin(mixin);
// Vue.use(LockPlugin);
Vue.use(VueClipboard);
Vue.use(Waves);
Vue.use(Bubble);
Vue.use(Zoom);
Vue.use(watermark);
Vue.use(Popover);
Vue.use(YachPopover);
Vue.use(Element);
Vue.use(OkrElCollapse);
Vue.use(OkrElCollapseItem);
Vue.config.productionTip = false;
Vue.filter("placeholder", placeholderFilter);
// Vue.filter("path", pathFilter);
Vue.filter("linebreak", linebreakFilter);

if (process.env.NODE_ENV == "production" && Vue.$ls.get("userInfo")) {
  Sentry.init({
    Vue,
    dsn: "https://5843e378f4fb47cf9e2e93f07f31bf3f@sentry.zhiyinlou.com/39",
    integrations: [new Integrations.BrowserTracing()],
    release: "0.1.4"
  });
  Sentry.configureScope(function(scope) {
    scope.setExtra("data", {
      work_code: Vue.$ls.get("userInfo").workcode || "",
      name: Vue.$ls.get("userInfo").name || ""
    });
  });
}
export const root = new Vue({
  router,
  i18n,
  store: createStore(),
  render: h => h(App)
});

root.$mount("#app");
